<svelte:options tag={null} />

<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  import type { OptionItems } from './optionbutton.types';
  export let checked: boolean;
  export let options: string;
  $: parsedOptions = options ? (JSON.parse(options) as OptionItems[]) : [];
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  let eventHandler = new EventHandler();

  function handleChange(option: OptionItems): void {
    option.checked = !option.checked;
    eventHandler.dispatch('change', option);
  }
</script>

<div class="mc-option-group {userClass}" {...attributes}>
  {#each parsedOptions as option}
    <div
      class="mc-option-button {option.fullwidth
        ? `mc-option-button--full`
        : ''}"
    >
      <input
        id={option.id}
        type="radio"
        class="mc-option-button__input"
        name={option.name}
        {checked}
        disabled={option.disabled}
        on:change={() => handleChange(option)}
      />
      <label for={option.id} class="mc-option-button__label">
        {option.label}
      </label>
    </div>
  {/each}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.option-button';

  .mc-option-group {
    display: flex;
    justify-content: space-between;
  }
</style>
